import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Modal, Input, message, Popconfirm, Spin, Button, Radio, Checkbox, Icon, Slider } from 'antd';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import TextQuestionEditModule from '../archive/TextQuestionEditModule';
import MediaQuestionEditModule from '../archive/MediaQuestionEditModule';
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

export default class ArchiveContentEditPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let role = CurrentRoleStore.getCurrentRole();
    this.state = {
      role,
      status: props.location.query.status?props.location.query.status : "editable",
      warn: props.location.query.warn,
      pageId: parseInt(props.location.query.pageId),
      templateId: parseInt(props.location.query.templateId),
      studentIds: JSON.parse(props.location.query.studentIds),
      studentId: JSON.parse(props.location.query.studentIds)[0],
      archiveId: parseInt(props.location.query.archiveId),
      studentNameArray: [],
      template:{},
      templateContainerView: {
        width: 550,
        height: 0
      },
      errorMsg: "",
      isShowTextQuestionBox: false,
      isShowMediaQuestionBox: false,
      isShowSubmitOrDraft: false,
      isShowSubmitError: false,
      isShowMediaBox: false,
      selectedArea: {},
      pushAnswer: [],
      pageContentId: null,
      detailShow: false,
      submitting: false,

      uploading: false,
      uploadedFiles: [],
      uploadingFiles: [],

      isShowAlbumBox: false,
      albums: [],
      semesters: []
    };
    // bind this
    this.showDetail = this.showDetail.bind(this);
    this.getTemplatesInfo = this.getTemplatesInfo.bind(this);
    this.toolAnswers = this.toolAnswers.bind(this);
    this.toolPushAnswers = this.toolPushAnswers.bind(this);
    this.toolData = this.toolData.bind(this);
    this._questionDetailView = this._questionDetailView.bind(this);
    this._questionView = this._questionView.bind(this);
    this._isShowSubmitErrorBox = this._isShowSubmitErrorBox.bind(this);
    this._isShowSubmitOrDraftBox = this._isShowSubmitOrDraftBox.bind(this);
    this.showQuestionBox = this.showQuestionBox.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onImageUpate = this.onImageUpate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
    this.destroyPageContents = this.destroyPageContents.bind(this);
    this.publishPageContents = this.publishPageContents.bind(this);
    this.onHideBox = this.onHideBox.bind(this);

    //upload
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);

    // album
    this.submitAlbum = this.submitAlbum.bind(this);

  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    this.getTemplatesInfo();
    this.state.studentIds.forEach((id)=>{
      DataService.getOneStudentInfo(id).then((student)=>{
        this.state.studentNameArray.push(student.full_name)
      }).catch((error)=>{
        console.log(error)
      })
    })
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  componentWillReceiveProps(newProps){
    // console.log(newProps)
  }

  destroyPageContents(data) {
    DataService.destroyPageContents(data).then((res) => {
    }).catch((error) => {
      console.log(error);
    });
  }

  publishPageContents() {
    DataService.batchPublishPageContents(JSON.stringify(this.state.studentIds), this.state.pageId).then((res) => {
      message.info("提交成功~", 1);
      this.setState({
        submitting: false
      });
      // hashHistory.push(`archive/record/index`);
      setTimeout(function() { hashHistory.goBack(); }, 1500);     // it may come from 'archive/record/index' or 'archive/review/classes/:classId'
    }).catch((error) => {
      console.log(error);
    });
  }

  onSubmit() {
    this.setState({submitting: true})
    let submitState = true, errorObject = {
      Text: 0,
      Filling: 0,
      Choice: 0,
      Audio: 0,
      Image: 0,
      Video: 0,
    };

    this.state.template.areas.forEach((area) => { 
      area.question_areas.forEach((question) => {
        if (question.type == "Text") {
          if (!question.hasAnswer && !question.questionToJson.auto_complete && !question.is_optional && !question.hideStatus) {
            submitState = false;
            for (var type in errorObject) {
              if (type == question.type) {
                errorObject[type]++;
              }
            }
          }
        } else if (!question.hasAnswer && !question.is_optional && !question.hideStatus) {
          submitState = false;
          for (var type in errorObject) {
            if (type == question.type) {
              errorObject[type]++;
            }
          }
        }
      })
    })

    if(this.state.isShowTextQuestionBox || this.state.isShowMediaQuestionBox){
      submitState = false;
    }

    if (submitState) {
      if (this.state.studentIds.length > 1 && !this.state.template.show_answer) {
        var that = this;
        this.setState({isShowSubmitOrDraft: true})
      } else {
        this.publishPageContents();
      }
    } else {
      var that = this;
      let errorMsg = '';
      for (var type in errorObject) {
        if (errorObject[type] > 0) {
          switch (type) {
            case 'Text':
              errorMsg = errorMsg + errorObject[type] + '道文字题,'
              break;
            case 'Filling':
              errorMsg = errorMsg + errorObject[type] + '道填空题,'
              break;
            case 'Choice':
              errorMsg = errorMsg + errorObject[type] + '道选择题,'
              break;
            case 'Image':
              errorMsg = errorMsg + errorObject[type] + '张图片,'
              break;
            case 'Audio':
              errorMsg = errorMsg + errorObject[type] + '段录音,'
              break;
            case 'Video':
              errorMsg = errorMsg + errorObject[type] + '段视频,'
              break;
          }
        }
      }
      this.setState({isShowSubmitError: true, errorMsg: errorMsg})
    }
  }

  onHideBox(){
    this.setState({
      isShowSubmitError: false,
      isShowSubmitOrDraft: false,
    })
  }

  _isShowSubmitErrorBox(){
    let errorMsg = `您还有${this.state.errorMsg.substring(0, this.state.errorMsg.length - 1)}未添加,请添加后再提交`;
    if(this.state.isShowTextQuestionBox || this.state.isShowMediaQuestionBox){
      errorMsg = "您还有未提交的题目，请再检查一遍"
    }
    return(
      <Modal
        title="未完成"
        okText="我知道了"
        visible={this.state.isShowSubmitError}
        onOk={this.onHideBox}
        onCancel={this.onHideBox}
      >
        <p>{errorMsg}</p>
      </Modal>
    )
  }

  _isShowSubmitOrDraftBox(){
    return(
      <Modal
        title="确认提交"
        okText="确认提交"
        cancelText="保存草稿"
        visible={this.state.isShowSubmitOrDraft}
        onOk={this.publishPageContents}
        onCancel={this.onSaveDraft}
      >
        <p>"确认提交"后,几个小孩主题内容一致,若个别小孩需要在做调整可点击"保存"内容将会存为草稿,您可单个小孩修改后提交</p>
      </Modal>
    )
  }

  getTemplatesInfo() {
    if(this.state.templateId){
      DataService.getTemplateById(this.state.templateId).then((template) => {
        if (this.state.studentIds.length > 1 && !template.show_answer) {
          let data = {
            page_id: this.state.pageId,
            student_ids: this.state.studentIds,
          }
          this.destroyPageContents(data);
        } else {
          DataService.getStudentArchiveStatus(this.state.archiveId, this.state.studentId).then((res) => {
            if (res.archive_status == "complete") {
              this.setState({
                status: 'viewonly'
              })
            }
          }).catch((error) => {
            console.log(error);
          });
        }
        var ratio = this.state.templateContainerView.width / template.width;
        var fontRatio = 0.3528 * ratio
        template.width = this.state.templateContainerView.width;
        template.height = 1.0 * ratio * template.height;
        DataService.getPageContents(this.state.pageId,this.state.studentId).then((res) => {
          if (template.areas) {
            // 封面页需要创建的答案个数
            let answersLenth = 0;
            template.areas.forEach((area) => {
              if (area.question_areas) {
                area.question_areas.forEach((q) => {
                  q.questionToJson = JSON.parse(q.question);
                  let answer;
                  if (res && !res.errors) {
                    answer = res.question_answers.find((answer) => answer.question_area_id == q.id);
                  }
                  if (!answer && (q.questionToJson.auto_complete == 'school_name' || q.questionToJson.auto_complete == 'name' || (q.questionToJson.auto_complete == 'full_name' && this.state.studentIds.length == 1))) {
                    answersLenth++;
                  }
                })
              }
            })
            this.setState({
              answersLenth: answersLenth,
              ratio: ratio,
              fontRatio: fontRatio,
            })

            if (template.t_type == 'album') {
              DataService.getOneStudentInfo(this.state.studentId).then((student) => {
                this.getAlbumList(res.template_answer, student.class_record_id);
                this.setState({
                  isShowAlbumBox: true
                })
              }).catch((error) => {
                console.log(error)
              })
            }

            if (this.state.role.roleName == 'teacher') {      // for teacher
              let classRecord = this.state.role.associatObj, auto_info = {};
              auto_info.school_name = classRecord.schoolName;
              auto_info.class_name = classRecord.className;
              if (this.state.studentIds.length == 1) {
                DataService.getOneStudentInfo(this.state.studentId).then((studentRes) => {
                  auto_info.full_name = studentRes.full_name;
                  auto_info.class_name = studentRes.class_record.name;
                  this.toolData(template, res, ratio, auto_info);
                });
              }else{
                auto_info.full_name = '';
                if (!auto_info.class_name) {
                  DataService.getOneStudentInfo(this.state.studentIds[0]).then((studentRes) => {
                    auto_info.class_name = studentRes.class_record.name;
                    this.toolData(template, res, ratio, auto_info);
                  });
                } else {
                  this.toolData(template, res, ratio, auto_info);
                }
              }
            } else if (this.state.role.roleName == 'parent') {   // for parent
              let associatObj = this.state.role.associatObj, auto_info = {};
              auto_info.school_name = associatObj.schoolName;
              auto_info.class_name =associatObj.className;
              auto_info.full_name = associatObj.full_name;
              this.toolData(template, res, ratio, auto_info);
            }
          }
          this.setState({
            pageContentId:res.id
          })
        }).catch((error) => {
          console.log(error)
          if (template.areas) {
            // 封面页需要创建的答案个数
            let answersLenth = 0;
            template.areas.forEach((area) => {
              if (area.question_areas) {
                area.question_areas.forEach((q) => {
                  q.questionToJson = JSON.parse(q.question);
                  let answer;
                  if (!answer && (q.questionToJson.auto_complete == 'school_name' || q.questionToJson.auto_complete == 'name' || (q.questionToJson.auto_complete == 'full_name' && this.state.studentIds.length == 1))) {
                    answersLenth++;
                  }
                })
              }
            })
            this.setState({
              answersLenth: answersLenth,
              ratio: ratio,
              fontRatio: fontRatio,
            })
            if (template.t_type == 'album') {
              DataService.getOneStudentInfo(this.state.studentId).then((student) => {
                this.getAlbumList({}, student.class_record_id);
                this.setState({
                  isShowAlbumBox: true
                })
              }).catch((error) => {
                console.log(error)
              })
            }

            if (this.state.role.roleName == 'teacher') {      // for teacher
              let classRecord = this.state.role.associatObj, auto_info = {};
              auto_info.school_name = classRecord.schoolName;
              auto_info.class_name = classRecord.className;
              if (this.state.studentIds.length == 1) {
                DataService.getOneStudentInfo(this.state.studentId).then((studentRes) => {
                  auto_info.full_name = studentRes.full_name;
                  auto_info.class_name = studentRes.class_record.name;
                  this.toolData(template, null, ratio, auto_info);
                });
              }else{
                auto_info.full_name = '';
                if (!auto_info.class_name) {
                  DataService.getOneStudentInfo(this.state.studentIds[0]).then((studentRes) => {
                    auto_info.class_name = studentRes.class_record.name;
                    this.toolData(template, null, ratio, auto_info);
                  });
                } else {
                  this.toolData(template, null, ratio, auto_info);
                }
              }
            } else if (this.state.role.roleName == 'parent') {   // for parent
              let associatObj = this.state.role.associatObj, auto_info = {};
              auto_info.school_name = associatObj.schoolName;
              auto_info.class_name =associatObj.className;
              auto_info.full_name = associatObj.full_name;
              this.toolData(template, null, ratio, auto_info);
            }
          }
        });
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  // 根据选项显示问题
  toolShowCondition(questions, index) {
    let hideQuestions = questions.filter((question) => {
      let q = question.questionToJson;
      // 筛选需要条件显示的
      if (q.show_condition && q.show_condition.length > 0) {
        if (index) {
          let status = false;
          q.show_condition.forEach((condition) => {
            // 筛选跟当前题目有关联的
            if (condition.sequence - 1 == index) {
              status = true;
            }
          })
          return status;
        } else {
          return true;
        }
      }
    });

    hideQuestions.map((q) => {
      let status = true;
      q.questionToJson.show_condition.forEach((condition) => {
        let checkedArr = questions[condition.sequence - 1].questionToJson.options.filter((option) => option.checked);
        condition.options.findIndex((option) => {
          let i = checkedArr.findIndex((item) => item.sequence == option);
          if (i < 0) {
            status = false;
          }
        })
      })
      q.hideStatus = !status;
    })
  }

  getAlbumList(answer = {}, classId) {
    DataService.getAlbumList(classId).then((res) => {
      if (answer.answer) {
        res.map((album) => {
          if (album.id == answer.answer) {
            album.selected = true;
          }
        })
      }

      let semesters = [];
      res.forEach((album) => {
        let has_status = false;
        semesters.forEach((semester) => {
          if (semester.semester == album.semester) {
            semester.albums.push(album)
            has_status = true;
          }
        })
        if (!has_status) {
          semesters.push({ semester: album.semester, albums: [album] });
        }
      })
      this.setState({
        albums: res,
        semesters,
        classId,
        originAlbumId: answer && answer.answer ? answer.answer : 0
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  onChangeAlbum(e) {
    this.state.albums.map((album) => {
      album.selected = false;
      if (album.id == Number(e.target.value)) {
        album.selected = true;
      }
    })
    this.setState({
      albums: this.state.albums
    });
  }

  toolQuestionType(type) {
    type = type.split('::')[1];
    return type;
  }

  toolAnswers(index) {
    index = Number(index);
    var that = this;
    let pushAnswer = this.state.pushAnswer;
    if (index < pushAnswer.length) {
      let { hasAnswer, questionId, data } = pushAnswer[index];
      DataService.toolAnswers(hasAnswer, questionId, data).then((res) => {
        that.toolAnswers(index + 1);
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.getTemplatesInfo();
    }
  }

  toolPushAnswers(auto_complete, questionId) {
    let data = {}, p = [];
    data.answer = {};
    data.answer.answer = auto_complete
    data.answer = JSON.stringify(data.answer);
    data.page_id = this.state.pageId;
    data.student_ids = JSON.stringify(this.state.studentIds);
    this.state.pushAnswer.push({
      hasAnswer: false,
      questionId: questionId,
      data: data,
    })
    this.setState({
      pushAnswer: this.state.pushAnswer
    })
    if (this.state.pushAnswer.length == this.state.answersLenth) {
      this.toolAnswers(0);
    }
  }

  toolData(result, res, ratio, auto_info) {
    result.areas.map((area) => {
      area.width = area.width * ratio;
      area.height = area.height * ratio;
      area.x = area.x * ratio;
      area.y = area.y * ratio;

      if (area.question_areas) {
        area.question_areas.map((question) => {
          question.width = question.width * ratio;
          question.height = question.height * ratio;
          question.x = question.x * ratio;
          question.y = question.y * ratio;
          question.questionToJson = JSON.parse(question.question);
          question.type = this.toolQuestionType(question.type);

          // 如果有答案
          if (res && !res.errors) {
            let answer = res.question_answers.find((answer) => answer.question_area_id == question.id);
            if (answer) {
              question.hasAnswer = true;

              question.questionToJson.answer = answer.answer;

              if (question.type == 'Image') {
                // 得到缩略图
                // 得到等比缩放图的高
                let imageHeight = (question.width / question.questionToJson.answer.width) * question.questionToJson.answer.height;
                if (question.height < imageHeight) {
                  question.questionToJson.answer.imageHeight = imageHeight;
                  question.questionToJson.answer.imageWidth = question.width;
                  question.questionToJson.answer.translateY = (question.questionToJson.answer.imageHeight - question.height) / 2;
                } else {
                  question.questionToJson.answer.imageWidth = (question.height / question.questionToJson.answer.height) * question.questionToJson.answer.width;
                  question.questionToJson.answer.imageHeight = question.height;
                  question.questionToJson.answer.translateX = (question.questionToJson.answer.imageWidth - question.width) / 2;
                }
              }else if(question.type == 'Video'){
                question.questionToJson.answer.imageWidth = question.width
              }
            }
          }

          // 封面页面自动填充
          if (question.questionToJson.auto_complete == "school_name") {
            question.questionToJson.auto_complete = auto_info.school_name;
          } else if (question.questionToJson.auto_complete == "class_name") {
            question.questionToJson.auto_complete = auto_info.class_name;
          } else if (question.questionToJson.auto_complete == "full_name") {
            question.questionToJson.auto_complete = auto_info.full_name;
          } else if (question.questionToJson.auto_complete == "semester_name"){
            let semester_name = ""
            question.questionToJson.auto_complete = semester_name;
          }
          if (question.questionToJson.auto_complete && !question.hasAnswer) {
            this.toolPushAnswers(question.questionToJson.auto_complete, question.id);
          }


          // 跳转判断 media页面 & 文字页面
          if (question.type == 'Video' || question.type == 'Audio' || question.type == 'Image') {
            area.questionType = 'media:' + question.type;
          } else {
            area.questionType = 'text';
            if (question.type == 'Filling') {
              question.questionToJson.titleArray = question.questionToJson.title.split('%%');
            }
          }
        })
      }
    })

    result.modality = result.modality ? (result.modality.length > 14 ? (result.modality.substring(0, 14) + '...') : result.modality) : '';
    this.setState({
      template: result,
      ratio
    })
  }

  _questionDetailView(question) {
    let q = question.questionToJson, ratio = this.state.ratio, fontRatio = this.state.fontRatio;
    // for special template, if should_render == true, should not render any text/filling/choice question
    if (this.state.template.should_render == false && (question.type == "Filling" || question.type == "Text" || question.type == "Choice"))
      return null;

    switch (question.type) {

      case "Filling":
        return (
          <div>{q.titleArray.map((text, index) =>
            <span key={index} style={{fontSize: q.font_size * fontRatio + 'px', color: '#' + q.text_color}}>
              <span>{text}</span>
              <span className={"no-answer-box" + ((question.hasAnswer || index >= q.titleArray.length - 1) ? " hidden" : "")} ></span>
              <span className={(!question.hasAnswer || index >= q.titleArray.length - 1) ? " hidden" : ""} style={{backgroundColor: '#' + q.highlight_background_color, color: '#' + q.highlight_text_color}}>{question.hasAnswer ? q.answer.answer[index] : ""}</span>
            </span>)}
          </div>
        )

      case "Text":
        return (
          <div>
            <span style={{fontSize: q.font_size * fontRatio + 'px', color: '#' + q.text_color, display: 'flex', justifyContent:(q.text_align?q.text_align:'left')}}>{question.hasAnswer ? q.answer.answer : q.title}</span>
          </div>
        )

      case "Choice":
        return (
          <div>
            {q.type == 'text' && <div style={{fontSize: q.title_font_size * fontRatio +'px'}}>{q.title}</div>}
            {q.type == 'image' && !question.hasAnswer && <img src={q.default_img} style={{width: question.width + 'px', height: question.height + 'px'}}/>}
            {q.options.map((option, index)=>
              <div key={index} style={{fontSize: q.option_font_size * fontRatio + 'px'}} >
                {q.type == 'text' && <img mode="aspectFill" src={(question.hasAnswer && option.sequence == q.answer.answer) ? 'template_selected_img.png' : 'template_unselected_img.png'} class="select-icon" style={{width: q.option_font_size+'px', height: q.option_font_size+'px'}} />}
                {q.type == 'text' && <span>{option.option}</span>}
                {q.type == 'image' && question.hasAnswer && option.sequence == q.answer.answer && <img src={option.selected_img} style={{width: question.width+'px', height: question.height+'px'}}/>}
              </div>
            )}
          </div>
        )

      case "Image":
        return (
          <div>
            <div style={{width: question.width, height: question.height}}>
              {question.hasAnswer && <img src={q.answer.url} style={{width: q.answer.imageWidth+'px', height: q.answer.imageHeight+'px'}}/>}
              {!question.hasAnswer && q.default_image &&<img src={q.default_image} style={{width: question.width+'px', height: question.height+'px'}}/>}
            </div>
          </div>
        )

      case "Video":
        return (
          <div>
          {question.hasAnswer &&
            <div style={{width: question.width, height: question.height}}>
              <img src={question.hasAnswer? q.answer.cover_image : q.default_image} style={{width: question.width, height: question.height}}/>
              <div className="audio-img"></div>
            </div>
          }
          </div>
        )

      case "Audio":
        return (
          <div>
            {(question.hasAnswer || q.default_image) ? <img src={question.hasAnswer ? q.play_image : q.default_image} style={{width: question.width+'px', height: question.height+'px'}} /> : ''}
          </div>
        )
    }
  }

  _questionView(question) {
    return (
      <div className="item" key={question.id} style={{width: question.width, height: question.height, left: question.x, top: question.y}}>
        {this._questionDetailView(question)}
      </div>
    )
  }

  showDetail(){
    this.setState({
      detailShow: !this.state.detailShow
    })
  }

  showQuestionBox(e){
    let selectedArea = JSON.parse(JSON.stringify(this.state.template.areas.find((area)=>{return area.id == parseInt(e.currentTarget.dataset.areaid)})))
    if (this.state.template.t_type == "no_render" && this.state.template.areas.length > 0) {
      var questions = [];
      this.state.template.areas.forEach((area) => {
        area.question_areas.forEach((q) => {
          questions.push(q)
        })
      })

      selectedArea.question_areas = questions;
    }
    let type = selectedArea.questionType.split(':');
    if(type[0] == "media"){
      if(selectedArea.question_areas[0].hasAnswer){  //已有答案时，显示右侧操作框更换或缩放。
        this.setState({
          isShowMediaQuestionBox: true,
          isShowTextQuestionBox: false,
          selectedArea: selectedArea,
        })
      }else {   //没有答案时
        console.log("select img")
        this.setState({
          selectedArea: selectedArea,
          isShowTextQuestionBox: false,
        })
      }

    }else{
      this.setState({
        isShowTextQuestionBox: true,
        isShowMediaQuestionBox: false,
        selectedArea: selectedArea,
      })
    }
  }

  onCancel(){
    this.setState({
      isShowTextQuestionBox: false,
      isShowMediaQuestionBox: false,
      selectedArea: {},
    })
  }

  onUpdate(areaId, questions){
    this.state.template.areas.forEach((area, index)=>{
      if (this.state.template.t_type == "no_render" && this.state.template.areas.length > 1) {
        area.question_areas.map((q) => {
          let question = questions.find((question) => question.id == q.id);
          q = Object.assign(q, question);
        })
      } else {
        if (area.id == areaId) {
          area.question_areas = questions;
          this.setState({
            selectedArea: area
          })
        }
      }
    })
    this.setState({
      template: this.state.template,
      isShowTextQuestionBox: false,
    })
  }

  onImageUpate(areaId, questions){
    let question = questions[0];
    let imageInfo = questions[0].questionToJson.answer;
    if(question.type == "Image" || question.type == "Video"){
      let imageHeight = (question.width / imageInfo.width) * imageInfo.height;

      if (question.height < imageHeight) {
        imageInfo.imageHeight = imageHeight;
        imageInfo.imageWidth = question.width;
        imageInfo.translateY = (imageInfo.imageHeight - question.height) / 2;
      } else {
        imageInfo.imageWidth = (question.height / imageInfo.height) * imageInfo.width;
        imageInfo.imageHeight = question.height;
        imageInfo.translateX = (imageInfo.imageWidth - question.width) / 2;
      }
    }
    this.state.selectedArea.question_areas = questions;
    this.setState({
      selectedArea: this.state.selectedArea,
    })
  }

  //upload
  getAvailableQuotaForUploadingFiles() {
    return true;
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading && this.state.uploadedFiles.length > 0;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true
    })
    message.loading("上传中...")
    return true;
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl, fileAdditionalInfo) {
    message.destroy()
    let imageInfo = {
      url: remoteUrl
    }
    let type = this.state.selectedArea.questionType.split(':')[1];
    if (type == 'Image') {
      imageInfo.width = fileAdditionalInfo.w;
      imageInfo.height = fileAdditionalInfo.h;
      this.state.selectedArea.question_areas[0].questionToJson.answer = imageInfo;
      this.onImageUpate(this.state.selectedArea.id, this.state.selectedArea.question_areas)
    }else if(type == "Video") {
      if(fileAdditionalInfo.length > this.state.selectedArea.question_areas[0].questionToJson.length){
        let maxLength = parseInt(this.state.selectedArea.question_areas[0].questionToJson.length / 60);
        maxLength > 0 ? message.warning(`上传视频请不要超过${maxLength}分钟`) : message.warning(`上传视频请不要超过${this.state.selectedArea.question_areas[0].questionToJson.length}秒`)
      }else {
        imageInfo.length = fileAdditionalInfo.length;
        imageInfo.width = fileAdditionalInfo.w;
        imageInfo.height = fileAdditionalInfo.h;
        imageInfo.cover_image = remoteUrl + '?vframe/jpg/offset/0.5';
        this.state.selectedArea.question_areas[0].questionToJson.answer = imageInfo;
        this.onImageUpate(this.state.selectedArea.id, this.state.selectedArea.question_areas)
      }
    }else if(type == "Audio") {
      if(fileAdditionalInfo.length > this.state.selectedArea.question_areas[0].questionToJson.length){
        let maxLength = parseInt(this.state.selectedArea.question_areas[0].questionToJson.length / 60);
        maxLength > 0 ? message.warning(`上传音频请不要超过${maxLength}分钟`) : message.warning(`上传音频请不要超过${this.state.selectedArea.question_areas[0].questionToJson.length}秒`)
      }else {
        imageInfo.length = fileAdditionalInfo.length;
        this.state.selectedArea.question_areas[0].questionToJson.answer = imageInfo;
        this.onImageUpate(this.state.selectedArea.id, this.state.selectedArea.question_areas)
      }
    }

    this.setState({
      uploading: false,
      uploadedFiles: remoteUrl,
      isShowMediaQuestionBox: true,
      selectedArea:this.state.selectedArea,
    });
  }

  onSaveDraft(){
    if(this.state.isShowTextQuestionBox || this.state.isShowMediaQuestionBox){
      this.state.isShowSubmitError = true;
    }else{
      message.info("保存成功~")
      setTimeout(function(){hashHistory.goBack()}, 1500)
    }

    this.setState({
      isShowSubmitOrDraft: false,
      isShowSubmitError: this.state.isShowSubmitError,
    })
  }

  _templateDetail() {
    return (
      <Modal
        title="模板介绍"
        visible={this.state.detailShow}
        onCancel={this.showDetail}
        footer={null}
      >
        <p style={{fontSize: '1.2rem',color: '#5B6273'}}>主题名字</p>
        <p style={{fontSize: '1rem'}}>{this.state.template.description}</p>
        <p style={{fontSize: '1.2rem',color: '#5B6273',paddingTop: '25px'}}>模板内容</p>
        <p style={{fontSize: '1rem'}}>{this.state.template.modality}</p>
      </Modal>
    )
  }

  submitAlbum() {
    let album = this.state.albums.find((album) => album.selected);
    if (!album) {
      message.error('请选择相册');
      return;
    }
    if (this.state.originAlbumId == album.id) {
      setTimeout(function () { hashHistory.goBack(); }, 1000);
      return
    }
    if (this.state.pageContentId) {
      DataService.batchClassPageContents(this.state.classId, this.state.pageId, album.id).then((res) => {
        message.info("相册更新成功~", 1);
        setTimeout(function () { hashHistory.goBack(); }, 1500);  
      }).catch((error) => {
        console.log("相册更新失败")
        message.error('相册更新失败，请重试');
      })
    } else {
      DataService.batchClassPageContents(this.state.classId, this.state.pageId, album.id).then((res) => {
        message.info("提交成功~", 1);
        setTimeout(function () { hashHistory.goBack(); }, 1500);  
      }).catch((error) => {
        console.log("提交失败")
        message.error('提交失败，请重试');
      })
    }
  }

  getSemesterToString(semester) {
    var year = semester.toString().substring(0, 4);
    var number = semester.toString().substring(4, 5);
    var yearSub = parseInt(year.toString().substring(2, 4));
    return (number == '1' ? yearSub + '-' + (yearSub + 1) + '学年上学期' : yearSub + '-' + (yearSub + 1) + '学年下学期');
  }

  _showAlbumModule() {
    let radioStyle = {
      display: 'block',
      margin: '10px 30px'
    }
    let album = this.state.albums.find((album) => album.selected);
    return (
      <div className="question-box">
        <div className="question-content">
          <div className="question-title">选择相册</div>
          <RadioGroup onChange={this.onChangeAlbum.bind(this)} value={album ? String(album.id) : ''}>
            {this.state.semesters.map((semester) => {
              return (
                <div key={semester.semester}>
                  <div style={{marginLeft: '10px'}}>{this.getSemesterToString(semester.semester)}</div>
                  {semester.albums.map((album) => 
                  <Radio style={radioStyle} value={String(album.id)} key={album.id}>
                    <img src={album.cover.indexOf('imageView2') < 0 ? (album.cover + '?imageView2/1/w/120') : album.cover} className="album-cover" />{album.title}
                  </Radio>)}
                </div>
              )
            })}
          </RadioGroup>
        </div>
        <div className="question-footer">
          <Button className="question-footer-btn" onClick={this.submitAlbum}>确 认</Button>
        </div>
      </div>
    )
  }

  render() {
    let mediaAreas = [], { ratio } = this.state;
    let TextAreas = [];
    if(this.state.template.areas){
      this.state.template.areas.forEach((area)=>{
        if(area.questionType == "media:Image" || area.questionType == "media:Video" || area.questionType == "media:Audio"){
          mediaAreas.push(area)
        }else {
          TextAreas.push(area)
        }
      })
    }
    return (
      <div className="archive-content-edit-page">
        <div className="archive-edit-container">
          <div className="archive-edit-template-info">
            <div className="archive-edit-template-title">{this.state.template.title}</div>
            <div className="archive-edit-template-detail" onClick={this.showDetail}>查看模板详情</div>
            <div className="archive-edit-template-students">选择宝贝：{this.state.studentNameArray.join('、')}</div>
          </div>
          {this._templateDetail()}
          <div className="archive-edit-template" style={{width: `${this.state.template.width}px`, height: `${this.state.template.height}px`}}>
            <img  style={{ width: `${this.state.template.width + 6 * ratio}px`, height: `${this.state.template.height + 6 * ratio}px`, position: "absolute", zIndex: 9, left: `${ratio * -3}px`, top: `${ratio * -3}px`}} 
                  src={this.state.template.bleed_url}
            />
            {TextAreas.map((area) =>
              <div key={area.id} className="item" style={{width: area.width, height: area.height, left: area.x, top: area.y, overflow: "hidden", zIndex: 10}} onClick={this.showQuestionBox} data-areaid={area.id}>
                {area.question_areas.map((question) =>
                  this._questionView(question)
                )}
              </div>
            )}

            {mediaAreas.map((area) =>
              <div key={area.id} className="item" style={{width: area.width, height: area.height, left: area.x, top: area.y, overflow: "hidden", zIndex: area.questionType == "media:Audio" ? 10 : 8}} onClick={this.showQuestionBox} data-areaid={area.id}>
                {area.question_areas.map((question) =>
                  this._questionView(question)
                )}
              </div>
            )}

            {mediaAreas.map((area) =>
              <div key={area.id} className="item" style={{width: area.width, height: area.height, left: area.x, top: area.y, overflow: "hidden", zIndex: 10}} onClick={this.showQuestionBox} data-areaid={area.id}>
                {!area.question_areas[0].hasAnswer && <ReactQiniuModule
                    className="upload-file"
                    onSuccess={this.onFileUploadSuccess}
                    onStartPermit={this.onFileStartUpload}
                    isAllFinish={this.isAllUploadingFileFinished}
                    getUploadQuota={this.getAvailableQuotaForUploadingFiles}
                    allowUploadFileTypes={area.question_areas[0].type == "Image" ? "IMAGES" :(area.question_areas[0].type == "Video" ? "VIDEOS" : "AUDIOS")}
                    allowUploadFileSize={area.question_areas[0].type == "Image" ? 20 : (area.question_areas[0].type == "Video" ? 200 : 0)} >
                </ReactQiniuModule>
              }
              </div>
            )}
          </div>
          {this.state.isShowTextQuestionBox && <TextQuestionEditModule area={this.state.selectedArea} pageId={this.state.pageId} studentIds={this.state.studentIds} onCancel={this.onCancel} onUpdate={this.onUpdate} />}
          {this.state.isShowMediaQuestionBox && <MediaQuestionEditModule area={this.state.selectedArea} pageId={this.state.pageId} studentIds={this.state.studentIds} onCancel={this.onCancel} onUpdate={this.onUpdate} />}
          {this.state.status != 'viewonly' && !this.state.isShowAlbumBox &&
            <div className="actions">
             {this.state.warn == 'true' && <div className="warn">该主题由家长填写</div>}
              <Button className="save-btn" onClick={this.onSaveDraft}>
                <Icon type="save" style={{fontSize: 20, color:"#FFF", verticalAlign: '-2px'}}/>
                保 存
              </Button>
              <Button className="submit-btn" onClick={this.onSubmit}>
                <Icon type="upload" style={{fontSize: 20, color:"#FFF", verticalAlign: '-2px'}}/>
                <span>{this.state.status == 'editable' ? '提 交' : (this.state.status == 'changeable' ? '确认修改' : '')}</span>
              </Button>
            </div>
          }
          {this.state.isShowAlbumBox ? this._showAlbumModule() : ''}
          {this._isShowSubmitErrorBox()}
          {this._isShowSubmitOrDraftBox()}
        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveContentEditPage.jsx